import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { BUSINESS } from "../../lib/site";

export default function MobileDock() {
  return (
    <div data-testid="mobile-dock" className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-navy/95 backdrop-blur-lg border-t border-deep p-3 flex gap-3">
      <a
        href={BUSINESS.phoneHref}
        data-testid="dock-call-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 bg-deep border border-sky/30 text-white font-heading font-bold text-sm py-3 rounded"
      >
        <Phone size={16} /> CALL NOW
      </a>
      <Link
        to="/booking"
        data-testid="dock-book-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 bg-brand text-white font-heading font-bold text-sm py-3 rounded"
      >
        <CalendarCheck size={16} /> BOOKING
      </Link>
    </div>
  );
}
